import { useState } from 'react';
import { signInWithGoogle, ALLOWED_DOMAIN } from '../firebase';

export default function Login() {
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSignIn() {
    setError('');
    setLoading(true);
    try {
      await signInWithGoogle();
    } catch (err) {
      setError(err.message || 'Sign-in failed. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-band">
          <img src="/v_transparent.png" alt="" />
          <div>
            <p className="login-wordmark">Chicago Venture Partners</p>
            <p className="login-wordmark-sub">Historical Market Cap</p>
          </div>
        </div>

        <div className="login-body">
          <h1 className="login-title">Sign in</h1>
          <p className="login-copy">
            This tool is restricted to <strong>@{ALLOWED_DOMAIN}</strong> Google accounts.
          </p>

          {error && <div className="login-error">{error}</div>}

          <button type="button" className="login-btn" onClick={handleSignIn} disabled={loading}>
            {loading ? (
              <>
                <span className="login-spinner" /> Signing in…
              </>
            ) : (
              <>
                <GoogleIcon /> Continue with Google
              </>
            )}
          </button>

          <p className="login-foot">Precise · Clear · Trusted</p>
        </div>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#4285F4" d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.48h4.84a4.14 4.14 0 0 1-1.8 2.72v2.26h2.92c1.7-1.57 2.68-3.88 2.68-6.62z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.47-.8 5.96-2.18l-2.92-2.26c-.8.54-1.84.86-3.04.86-2.34 0-4.32-1.58-5.02-3.7H.96v2.33A9 9 0 0 0 9 18z" />
      <path fill="#FBBC05" d="M3.98 10.72a5.4 5.4 0 0 1 0-3.44V4.95H.96a9 9 0 0 0 0 8.1l3.02-2.33z" />
      <path fill="#EA4335" d="M9 3.58c1.32 0 2.5.45 3.44 1.35l2.58-2.58C13.46.9 11.43 0 9 0A9 9 0 0 0 .96 4.95l3.02 2.33C4.68 5.16 6.66 3.58 9 3.58z" />
    </svg>
  );
}
